import cn from "classnames";
import moment from "moment";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LightBoxGallery } from "ui";

import { UnverifiedResellerInfoProps } from "./UnverifiedResellerInfo.types";

import styles from "./UnverifiedResellerInfo.module.scss";

const UnverifiedResellerInfo = ({ reseller }: UnverifiedResellerInfoProps) => {
  const { t } = useTranslation();
  const [openedImageIndex, setOpenedImageIndex] = useState<number>();

  const galleryMediaList = useMemo(
    () => [
      reseller.personVerificationImage,
      reseller.frontDocumentImage,
      reseller.backDocumentImage
    ],
    [reseller]
  );

  return (
    <>
      <div className={styles.resellerInfo}>
        <ul className={styles.resellerInfo_textInfo}>
          <li>
            <h4 className={styles.resellerInfo_title}>{t("Full Name")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {`${reseller.firstname} ${reseller.lastname}`}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>{t("Gender")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {reseller.gender}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>{t("Birthday")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {`${moment(reseller.birthday).format("MMMM DD, YYYY")} (${reseller.age} y.o.) `}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>{t("Location")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {`${reseller.country}, ${reseller.city}`}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>{t("Phone")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {`${reseller.phoneNumber}`}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>{t("Mobile Money")}</h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {reseller.mobileMoneyNumber}
            </p>
          </li>

          <li>
            <h4 className={styles.resellerInfo_title}>
              {t("Registration date")}
            </h4>
            <p className={styles.resellerInfo_textInfo_value}>
              {moment(reseller.createdAt).format("DD/MM/YYYY, HH:mm")}
            </p>
          </li>
        </ul>

        <div className={styles.resellerInfo_separator} />

        <div className={styles.resellerInfo_photoContainer}>
          <h4 className={styles.resellerInfo_title}>{t("User photo")}</h4>
          <div className={styles.resellerInfo_userPhotoThumb}>
            <img
              onClick={() => setOpenedImageIndex(0)}
              className={cn("default-image", styles.resellerInfo_image)}
              src={reseller.personVerificationImage.url}
            />
          </div>
        </div>

        <div className={styles.resellerInfo_photoContainer}>
          <h4 className={styles.resellerInfo_title}>{t("Front of ID")}</h4>
          <div className={styles.resellerInfo_documentPhotoThumb}>
            <img
              onClick={() => setOpenedImageIndex(1)}
              className={styles.resellerInfo_image}
              src={reseller.frontDocumentImage.url}
            />
          </div>
        </div>

        <div className={styles.resellerInfo_photoContainer}>
          <h4 className={styles.resellerInfo_title}>{t("Back of ID")}</h4>
          <div className={styles.resellerInfo_documentPhotoThumb}>
            <img
              onClick={() => setOpenedImageIndex(2)}
              className={styles.resellerInfo_image}
              src={reseller.backDocumentImage.url}
            />
          </div>
        </div>
      </div>

      <LightBoxGallery
        mediaList={galleryMediaList}
        openedImageIndex={openedImageIndex}
        setOpenedImageIndex={setOpenedImageIndex}
      />
    </>
  );
};

export default UnverifiedResellerInfo;
